import { useMemo, useState } from "react";
import { Case } from "../../../models/case";
import CaseRow from "./case-row";

function CasesList({ query, cases }: { query: string; cases: Case[] }) {
  const [sortKind, setSortKind] = useState<"caseNumber" | "address" | "buyersAgent">("caseNumber");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("desc");

  const sortedItems = useMemo(() => {
    let items = [...(cases || [])];
    items.sort((a, b) => {
      let aSort = `${(a as any)[sortKind]}`.toLowerCase();
      let bSort = `${(b as any)[sortKind]}`.toLowerCase();
      if (aSort > bSort) return sortDirection === "asc" ? 1 : -1;
      if (aSort < bSort) return sortDirection === "asc" ? -1 : 1;
      return 0;
    });
    if (query) {
      return items.filter((item) =>
        `${item.address}`.toLowerCase().includes(query.toLowerCase()) ||
        `${item.caseNumber}`.toLowerCase().includes(query.toLowerCase())
      );
    }
    return items;
  }, [cases, sortKind, sortDirection, query]);

  const SortHeader = ({ col, label }: { col: typeof sortKind; label: string }) => (
    <th
      style={{ cursor: "pointer", userSelect: "none" }}
      onClick={() => {
        if (sortKind === col) setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        else { setSortKind(col); setSortDirection("asc"); }
      }}
    >
      {label} {sortKind === col ? (sortDirection === "asc" ? "↑" : "↓") : ""}
    </th>
  );

  return (
    <table className="p-table">
      <thead>
        <tr>
          <SortHeader col="caseNumber" label="Case #" />
          <SortHeader col="address" label="Property" />
          <SortHeader col="buyersAgent" label="Buyer's Agent" />
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {sortedItems.length === 0 ? (
          <tr>
            <td colSpan={5} style={{ textAlign: "center", color: "var(--ink-soft)", padding: "40px 24px" }}>
              No cases found.
            </td>
          </tr>
        ) : (
          sortedItems.map((item, index) => (
            <CaseRow key={`case-${index}`} caseObject={item} />
          ))
        )}
      </tbody>
    </table>
  );
}

export default CasesList;
